export enum LoanTypes {
  RENTAL = "Rental",
  FF = "Fix and Flip",
  BIDGE = "Bridge",
}

export enum LoanPurposes {
  PURCHASE = "Purchase",
  REFI = "Refinance",
}